var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconFolder = function SvgIconFolder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2777 4.18182L6.61103 2H1.88881C1.74147 2 1.60016 2.05747 1.49597 2.15976C1.39178 2.26205 1.33325 2.40079 1.33325 2.54545V12.3636C1.33325 12.7976 1.50885 13.2138 1.82141 13.5207C2.13397 13.8276 2.55789 14 2.99992 14H12.9999C13.4419 14 13.8659 13.8276 14.1784 13.5207C14.491 13.2138 14.6666 12.7976 14.6666 12.3636V4.72727C14.6666 4.58261 14.6081 4.44387 14.5039 4.34158C14.3997 4.23929 14.2584 4.18182 14.111 4.18182H8.2777Z",
    fill: "#6E6F83"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFolder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconFolder.790dcad2.svg";
export { ForwardRef as ReactComponent };